export type IDiscussionType = number | string;
export type ICountValue = number | string;
export type IOpenDiscussionFn = (id: string, type: number, location: string, smallCommentField?: boolean) => unknown;

export interface IListener {
    setCountInWidgets(id: string, count: number): unknown;
    setEnabled(id: string, enabled: boolean): unknown;
}

interface ICounterWidget {
    counters: number;
    count: number;
}
interface IWidgetSet {
    [key: string]: ICounterWidget;
}

const widgetSet: IWidgetSet = {};
const listenerList: IListener[] = [];

let openDiscussionFn: IOpenDiscussionFn | undefined;

function setCountInWidgets(id: string, count: number) {
    if (!isNaN(count)) {
        const widget = widgetSet[id];
        if (widget && widget.count !== count) {
            listenerList.forEach(function (listener) {
                listener.setCountInWidgets(id, count);
            });

            widget.count = count;
        }
    }
}

function setEnabledInWidgets(id: string, enabled: boolean) {
    listenerList.forEach(function (listener) {
        listener.setEnabled(id, enabled);
    });
}

export function makeKey(id: string, type: IDiscussionType): string {
    return type + '_' + id;
}

export function getOpenDiscussionFn() {
    return openDiscussionFn;
}

export function setOpenDiscussionFn(fn: IOpenDiscussionFn) {
    openDiscussionFn = fn;
}

/**
 * @param id
 *      Идентификатор дискуссии.
 * @param type
 *      Тип дискуссии.
 * @param delta
 *      Кол-во новых комментариев.
 */
export function updateCount(id: string, type: IDiscussionType, delta: ICountValue) {
    delta = parseInt(delta as string, 10);
    const key = makeKey(id, type);
    const widget = widgetSet[key];
    if (widget && !isNaN(delta)) {
        const currentCount = widget.count;
        if (typeof currentCount === 'number' && !isNaN(currentCount)) {
            setCountInWidgets(key, currentCount + delta);
        }
    }
}

/**
 * @param discussionId
 *      Идентификатор дискуссии.
 * @param discussionType
 *      Тип дискуссии.
 * @param count
 *      Общее кол-во комментариев в дискуссии.
 */
export function setCount(discussionId: string, discussionType: IDiscussionType, count: ICountValue) {
    setCountInWidgets(
        makeKey(discussionId, discussionType),
        parseInt(count as string, 10)
    );
}

export function setEnabled(discussionId: string, discussionType: IDiscussionType, enabled: boolean) {
    setEnabledInWidgets(
        makeKey(discussionId, discussionType),
        enabled
    );
}

export function registerCounter(key: string, count: ICountValue) {
    let widget = widgetSet[key];
    count = parseInt(count as string, 10);

    if (!widget) {
        widget = widgetSet[key] = {
            counters: 0,
            count
        };
    }

    //считаем, количество компонентов со счетчиком
    widget.counters += 1;

    setCountInWidgets(key, count);
}

export function unregisterCounter(key: string) {
    const widget = widgetSet[key];
    if (widget) {
        widget.counters -= 1;
        if (widget.counters < 1) {
            delete widgetSet[key];
        }
    }
}

export function addListener(listener: IListener) {
    listenerList.push(listener);
}
